import { ContactType } from '@api';
import {
  faEnvelope,
  faFax,
  faMobile,
  faPhone,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Stack } from '@mantine/core';
import { EmailAnchor } from '../EmailAnchor';
import { PhoneNumberAnchor } from '../PhoneNumberAnchor';
import classes from './ContactDetails.module.css';

const GAP = 'xs';

type ContactDetailsPropsType = {
  contact: ContactType;
};

export const ContactDetails: React.FC<ContactDetailsPropsType> = ({
  contact,
}) => {
  const { phone, mobile, fax, email } = contact;

  return (
    <Stack gap={0}>
      {phone && (
        <Group gap={GAP} className={classes.contactDetailsGroup}>
          <FontAwesomeIcon icon={faPhone} />
          <PhoneNumberAnchor phoneNumber={phone} />
        </Group>
      )}
      {mobile && (
        <Group gap={GAP} className={classes.contactDetailsGroup}>
          <FontAwesomeIcon icon={faMobile} />
          <PhoneNumberAnchor phoneNumber={mobile} />
        </Group>
      )}
      {fax && (
        <Group gap={GAP} className={classes.contactDetailsGroup}>
          <FontAwesomeIcon icon={faFax} />
          <PhoneNumberAnchor phoneNumber={fax} />
        </Group>
      )}
      {email && (
        <Group gap={GAP} className={classes.contactDetailsGroup}>
          <FontAwesomeIcon icon={faEnvelope} />
          <EmailAnchor email={email} />
        </Group>
      )}
    </Stack>
  );
};
